import { createSelector } from 'reselect';
import constants from './constants';

const selectLoader = (state) => state.loader;

export const getLoader = () =>
  createSelector(selectLoader, (state) => state.loaders[constants.LOADER]);
export const getSpecifLoader = (loader) =>
  createSelector(selectLoader, (state) => !!state.loaders[loader]);
